// 缓存模块
export const CacheModule = {
  setSessionStorage(key, value) {
    if (window.sessionStorage) {
      let storage = window.sessionStorage;
      storage.setItem(key, JSON.stringify(value));
    } 
  },
  // sessionStorage get
  getSessionStorage(value) {
    if (window.sessionStorage) {
      let str = window.sessionStorage;
      let val = str.getItem(value);
      let parmer = JSON.parse(val);
      return parmer;
    } 
  },
  removeSessionStorage(value) {
    if (window.sessionStorage) {
      sessionStorage.removeItem(value);
    }
  },
  // 设置缓存值localStorage
  set(key, value) {
    if (window.localStorage) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  },
  // 得到缓存值
  get(value) {
    if (window.localStorage) {
      var val = localStorage.getItem(value);
      let parmer = JSON.parse(val);
      return parmer;
    } 
  },
  // 删除缓存值
  remove(key) {
    if (window.localStorage) {
      localStorage.removeItem(key);
    }
  },
};
export const getAppClient = () => {
  var ua = navigator.userAgent.toLowerCase();
  // JSAPI-公众号, MWEB-H5浏览器,APP-app
  if (
    window.__wxjs_environment === "miniprogram" ||
    window.globalEvn === "miniprogram"
  ) {
    //微信小程序
    return "wxCode";
  } else if (ua.indexOf("micromessenger") !== -1) {
    //微信浏览器
    return "JSAPI";
  } else if (ua.indexOf("SOYOUNG") !== -1 || ua.indexOf("soyoung") !== -1) {
    //新氧app
    return "APP";
  } else {
    //手机浏览器
    return "MWEB";
  }
};
export const browserType = () => {
  var browser = {
    versions: (function() {
      var u = navigator.userAgent;
      // var app = navigator.appVersion;
      return {
        //移动终端浏览器版本信息
        trident: u.indexOf("Trident") > -1, //IE内核
        presto: u.indexOf("Presto") > -1, //opera内核
        webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
        iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1, //是否iPad
        webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
      };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase(),
  };
  if (browser.versions.mobile) {
    //判断是否是移动设备打开。browser代码在下面
    var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //在微信中打开
      return 'wx'
      // alert("微信中");
    }
    if (ua.match(/WeiBo/i) == "weibo") {
      //在新浪微博客户端打开
      return 'xlwb'
    }
    if (ua.match(/QQ/i) == "qq") {
      //在QQ空间打开
      return 'qq'
    }
    if (browser.versions.ios) {
      //是否在IOS浏览器打开
      return 'IOS'
    }
    if (browser.versions.android) {
      //是否在安卓浏览器打开
      return 'anzhuo'
    }
  } else {
    //否则就是PC浏览器打开
    return ''
  }
};
